/** @format */

import dynamic from "next/dynamic";
import { Layout } from "../components/common/Layout";
import { useRouter } from "next/router";
import { v4 as uuidv4 } from "uuid";
const NotFound = dynamic(() => import("../components/NotFound/NotFound"), {ssr: false});
const Spinner = dynamic(() => import("../components/Spinner/Spinner"), {ssr: false});
const ProductListing = dynamic(() =>
  import("../components/ProductListing/ProductListing"), {ssr: false}
);
import { useEffect } from 'react';

export default function ListingPage({ data }) {
  const router = useRouter();
  const { categoryId = "" } = data || {};

  if (data?.error?.status) {
    return (
      <>
        <NotFound />
      </>
    );
  }

  const meta = {
    title: `Buy ${categoryId
      ?.split("-")
      ?.join(
        " "
      )} wholesale from Indian suppliers.Shop thousands of products wholesale | Qalara`,
    description: `Looking to buy wholesale  ${categoryId
      ?.split("-")
      ?.join(
        " "
      )} from Indian manufacturers? Source online with ease from Qalara.com, your reliable partner for ${categoryId
      ?.split("-")
      ?.join(" ")} from India and South East Asia.`,
    keywords: `${categoryId?.split("-")?.join(" ")} wholesale, ${categoryId
      ?.split("-")
      ?.join(" ")} sourcing, ${categoryId
      ?.split("-")
      ?.join(" ")} manufacturers, ${categoryId
      ?.split("-")
      ?.join(" ")} South East Asia, ${categoryId
      ?.split("-")
      ?.join(" ")} exporters`,
    url: `/products/${categoryId}`,
  };
  useEffect(() => {
    const handlePopState = () => {
      window.location.reload(); // Ensures the correct page loads
    };
  
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  if (router.isFallback) {
    return <Spinner />;
  }
  return (
    <Layout meta={meta}>
      <ProductListing data={data} pagetype="GB" />
    </Layout>
  );
}

const getURL = () => {
  return (
    process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL +
    "/search/v1/custom-plp?sort_by=popularity&sort_order=DESC&size=30&from=0"
  );
};

export const getStaticProps = async () => {
  let res;
  const error = { status: false };
  try {
    const response = await fetch(getURL(), {
      method: "GET",
      headers: {
        "trace-id": uuidv4(),
      },
    });
    res = await response.json();
  } catch (error) {
    error["status"] = true;
  }
  return {
    props: {
      data: {
        slp_count: res?.totalHits || null,
        slp_content: res?.products || null,
        slp_facets: res?.aggregates || null,
        slp_categories: res?.fixedAggregates || null,
        gb: true,
        categoryId: "all-categories",
        error: error,
      },
    },
    revalidate: 14400,
  };
};
